import React, {
  useContext,
  Fragment,
  useEffect,
  useState,
  useRef,
} from "react";
import { Alert, Button, Card, Col, Modal, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import _, { map } from "lodash";
import ContextApp from "../../../../core/contexts/context.app";
import "animate.css";
import moment from "moment-jalaali";
import { Zoom, Fade } from "react-awesome-reveal";

import {
  IconArrowRight,
  IconPhone,
  IconChevronLeft,
  IconClosePaper,
  IconErrorCircle,
  IconGift,
  IconInfo,
  IconNoTicket,
  IconLock,
  IconPeople,
  IconForbidden,
  IconHourGlass,
} from "../../../../assets/icons";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import ServiceStorage from "../../../../core/services/service.storage";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { isMobile } from "react-device-detect";
import ApiAmusementService from "../../../../core/api/api.amusementService";
import { BasketHelper } from "../../../../core/utils/BasketHelper";
import SplitNumber from "../../../components/SplitNumber";
import SkeletonModalReserveItem from "../../../components/SkeletonComponent/SkeletonModalReserveItem";

function ReserveModal({ showReserveModal, setShowReserveModal, serviceInfo }) {
  const list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const ctx = useContext(ContextApp);
  const [loadingDot, setLoadingDot] = useState(false);

  const [modalInfo, setModalInfo] = useState({ show: false, text: "" });
  //داده های مربوط به هر سانس
  const swiperRef = useRef(null);

  const [loadingData, setLoadingData] = useState(true);
  const [firstSelectableDateIndex, setFirstSelectableDateIndex] = useState(0);
  const [loadingSwiperDate, setLoadingSwiperDate] = useState(false);
  const [calendar, setCalendar] = useState([]);
  const [reserveDetail_V2, setReserveDetail_V2] = useState([]);
  const [reserveDetail_V2Descriptions, setReserveDetail_V2Descriptions] =
    useState();
  const [
    amusementServiceReserveItemGroups,
    setAmusementServiceReserveItemGroups,
  ] = useState([]);
  const [amusementServiceReserveItems, setAmusementServiceReserveItems] =
    useState([]);
  const [basket, setBasket] = useState();
  const [selectedDate, setSelectedDate] = useState();
  let showActiveDate = false;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await ApiAmusementService.getAmusementServiceReserveDetail_V2({
            urlName: serviceInfo.urlName,
          });
        const reserveDetail_V2_1 = JSON.parse(response.reserveDetail_V2);
        const fI = reserveDetail_V2_1.findIndex((a) => a.dIA === true);
        if (fI > 2) {
          setFirstSelectableDateIndex(fI - 2);
        } else setFirstSelectableDateIndex(0);

        setLoadingSwiperDate(true);
        setCalendar(response.fullDateTimeDtos);
        const reserveDetail_V2Descriptions_1 = JSON.parse(
          response.reserveDetail_V2Descriptions
        );
        setReserveDetail_V2Descriptions(reserveDetail_V2Descriptions_1);
        const amusementServiceReserveItemGroups_1 =
          response.amusementServiceReserveItemGroups;
        setAmusementServiceReserveItemGroups(
          amusementServiceReserveItemGroups_1
        );

        const amusementServiceReserveItems_1 =
          response.amusementServiceReserveItems;
        setAmusementServiceReserveItems(amusementServiceReserveItems_1);
        let firstSelectableDate = _.find(reserveDetail_V2_1, { dIA: true });
        if (!_.isNil(firstSelectableDate)) {
          let fullDateTimeDtos_firstSelectableDate = _.find(
            response.fullDateTimeDtos,
            function (i) {
              return i.year + i.month + i.day == firstSelectableDate.d;
            }
          );
          setSelectedDate(
            !_.isNil(fullDateTimeDtos_firstSelectableDate)
              ? fullDateTimeDtos_firstSelectableDate
              : response.fullDateTimeDtos[0]
          );
        } else setSelectedDate(response.fullDateTimeDtos[0]);

        setReserveDetail_V2(reserveDetail_V2_1);
        setLoadingData(false);
      } catch (error) {
      } finally {
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    (async () => {
      let basketTemp = await BasketHelper.getBasketFromStorage(ctx);
      if (!_.isEmpty(basketTemp)) {
        setBasket(basketTemp);
      }
    })();
  }, [ctx.basketInfo]);

  const createDatePickerSlider = () => {
    return calendar.map(function (item, index) {
      var currentDateData = _.find(reserveDetail_V2, {
        d: item.year + item.month + item.day,
      });
      // var currentDateData = reserveDetail_V2.filter(
      //   (date) => date.d == item.year + item.month + item.day
      // );
      if (!_.isNil(currentDateData))
        //----- نمایش همه تاریخ هادر صورتی که showActiveDate فعال نشده باشد------------------------------
        return !showActiveDate ? (
          <SwiperSlide key={item.id}>
            <Card
              onClick={() => {
                setSelectedDate(item);
              }}
              className={classNames(
                "text-center fs-085 ",
                item.index === 0 ? " today " : null,
                !currentDateData.dIA && item != selectedDate
                  ? " opacity-25 "
                  : null,
                item === selectedDate ? " active" : null
              )}
            >
              <Card.Body className="py-2 px-1">
                <>
                  <div>{item.persianDayOfWeek}</div>
                  <div className="fs-075 pt-1">{item.date}</div>
                  {/* <div className="fs-075 pt-1">{!currentDateData[0].dIA && "تعطیل"}</div> */}
                </>
              </Card.Body>
            </Card>
          </SwiperSlide>
        ) : (
          //----- نمایش همه تاریخ هادر صورتی که showActiveDate فعال شده باشد------------------------------
          currentDateData.dIA && (
            <SwiperSlide key={item.id}>
              <Card
                onClick={() => {
                  setSelectedDate(item);
                }}
                className={classNames(
                  "text-center fs-085 ",
                  item.index === 0 ? " today " : null,

                  item === selectedDate ? " active" : null
                )}
              >
                <Card.Body className="py-2 px-1">
                  <>
                    <div>{item.persianDayOfWeek}</div>
                    <div className="fs-075 pt-1">{item.date}</div>
                    {/* <div className="fs-075 pt-1">{!currentDateData[0].dIA && "تعطیل"}</div> */}
                  </>
                </Card.Body>
              </Card>
            </SwiperSlide>
          )
        );
    });
  };
  const createReserveForm = () => {
    if (_.isNil(selectedDate))
      return (
        <>
          <div></div>
        </>
      );
    const selectedDateData = _.find(reserveDetail_V2, {
      d: selectedDate.year + selectedDate.month + selectedDate.day,
    });
    const selectedDateDescription = _.find(reserveDetail_V2Descriptions, {
      id: _.toString(selectedDateData?.dDesId),
    });
    return (
      <>
        {loadingDot ? (
          <div className="loading-form">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={loadingDot ? " opacity-0" : " opacity-1"}>
          {!_.isNil(selectedDateData?.g) &&
          _.isArray(selectedDateData?.g) &&
          selectedDateData.g.length > 0 &&
          selectedDateData.dIA ? (
            <div>
              {selectedDateDescription?.desc.length > 0 ? (
                <div className="text-orange px-2 py-1 fs-075  mb-4">
                  {selectedDateDescription?.desc}
                </div>
              ) : (
                ""
              )}
              <Fade key={selectedDateData.d} triggerOnce="true">
                {amusementServiceReserveItemGroups.map(function (groupData) {
                  const group = selectedDateData.g.filter(
                    (g) => g.gId === groupData.id
                  )[0];
                  // const groupData = amusementServiceReserveItemGroups.filter(
                  //   (g) => g.id === group.gId
                  // )[0];
                  const group_ReceptionHoursAreOver =
                    selectedDate == calendar[0] &&
                    _.toInteger(selectedDate.hour + selectedDate.minute) >
                      _.toInteger(
                        _.split(groupData.reservationExpirationTime, ":")[0] +
                          _.split(groupData.reservationExpirationTime, ":")[1]
                      );
                  const groupDescription = _.find(
                    reserveDetail_V2Descriptions,
                    {
                      id: group?.gDesId,
                    }
                  );
                  if (
                    !_.isNil(group) &&
                    group.gID &&
                    _.find(group?.i, { iID: true })
                  )
                    return (
                      <>
                        <div
                          className="items-box mt-3 mb-4"
                          style={{
                            pointerEvents: !group.gIA ? "none" : "auto",
                          }}
                          key={groupData.id}
                        >
                          {!group.gIA && (
                            <div className=" rotated-text">
                              {groupDescription?.desc.length > 0 ? (
                                <p>{groupDescription?.desc}</p>
                              ) : (
                                <p>عـدم فعـالـیت</p>
                              )}
                            </div>
                          )}

                          <div className="items-box-header bg-white rounded-2 py-1  ps-2 pe-2 ms-2 fs-085 fw-bold ">
                            {groupData.title}{" "}
                            {!_.isNil(groupData.tooltip) &&
                              !_.isEmpty(groupData?.tooltip) && (
                                <span
                                  onClick={(e) => {
                                    setModalInfo({
                                      show: true,
                                      text: groupData.tooltip,
                                    });
                                  }}
                                  className="btn btn-light border px-1 py-0 btn-sm fw-normal fs-07"
                                >
                                  {/* <IconInfo fillColor="#444" /> */}
                                  توضیحات
                                </span>
                              )}
                          </div>
                          <div className="item-box-body pt-3 px-2 ">
                            {groupDescription?.desc.length > 0 ? (
                              <div className="text-orange  px-2 pb-2 fs-075">
                                {groupDescription?.desc}
                              </div>
                            ) : (
                              ""
                            )}

                            {amusementServiceReserveItems.map(function (
                              itemData
                            ) {
                              const item = _.find(group.i, {
                                iId: itemData.id,
                              });
                              const itemBasketCount = _.find(
                                basket?.basketItemTemps,
                                {
                                  isDeleted: false,
                                  amusementServiceReserveItemGroupId:
                                    groupData.id,
                                  amusementServiceReserveItemId: itemData.id,
                                  checkInDate: selectedDate.date,
                                }
                              )?.totalCount;

                              const item_ReceptionHoursAreOver =
                                selectedDate == calendar[0] &&
                                _.toInteger(
                                  selectedDate.hour + selectedDate.minute
                                ) >
                                  _.toInteger(
                                    _.split(
                                      itemData.reservationExpirationTime,
                                      ":"
                                    )[0] +
                                      _.split(
                                        itemData.reservationExpirationTime,
                                        ":"
                                      )[1]
                                  );
                              if (
                                !_.isNil(item) &&
                                item.iID &&
                                itemData.isActive
                              )
                                return (
                                  <>
                                    <div
                                      key={itemData.id}
                                      className={classNames(
                                        "item-box-row px-2 selected-item mt-2 mb-3 pt-2 pb-2 border",
                                        itemBasketCount > 0 ? "active" : "",
                                        itemData.isFullCapacity ||
                                          item.iIFC ||
                                          group_ReceptionHoursAreOver ||
                                          item_ReceptionHoursAreOver ||
                                          !item.iIA ||
                                          !itemData.isActive
                                          ? "opacity-60"
                                          : ""
                                      )}
                                    >
                                      <Row
                                        className="gx-0 mb-1  fw-bold"
                                        style={{
                                          pointerEvents: !item.iIA
                                            ? "none"
                                            : "auto",
                                        }}
                                      >
                                        <Col
                                          className={classNames("fs-08", {
                                            " text-success fw-bold ":
                                              selectValue[itemData.id] > 0,
                                          })}
                                        >
                                          {itemData.title}
                                          {!_.isNil(itemData.tooltip) &&
                                            !_.isEmpty(itemData?.tooltip) && (
                                              <span
                                                className="ps-1 small-svg-1"
                                                onClick={(e) => {
                                                  setModalInfo({
                                                    show: true,
                                                    text: itemData.tooltip,
                                                  });
                                                }}
                                              >
                                                <IconInfo fillColor="#444" />
                                              </span>
                                            )}
                                        </Col>
                                        {/* {!itemData.isFullCapacity &&
                                    !item.iFC &&
                                    !group_ReceptionHoursAreOver &&
                                    !item_ReceptionHoursAreOver && (
                                      <Col
                                        xs="auto"
                                        className="text-center fs-075"
                                        style={{ width: "60px" }}
                                      >
                                        تعداد
                                      </Col>
                                    )} */}
                                      </Row>
                                      <Row className="gx-0  ">
                                        <Col className="fs-08 my-auto  text-black-4">
                                          {itemData.originalPrice >
                                          itemData.price ? (
                                            <>
                                              <span className="text-decoration-line-throught-rotate border-secondary">
                                                <SplitNumber
                                                  number={
                                                    itemData.originalPrice
                                                  }
                                                />
                                              </span>
                                              <span className="fs-075">
                                                تومان
                                              </span>
                                              <div className="fs-075 text-danger mb-1 small-svg">
                                                <IconGift fillColor="#f80248" />
                                                <SplitNumber
                                                  number={
                                                    itemData.originalPrice -
                                                    itemData.price
                                                  }
                                                ></SplitNumber>
                                              </div>
                                            </>
                                          ) : (
                                            "قیمت نهایی :"
                                          )}
                                        </Col>
                                        {/* <Col xs="2" className="text-center my-auto">
                                     <div className="fs-075 bg-gray-5 text-danger rounded-pill d-inline-block px-2 px-lg-3">
                                      {((itemData.originalPrice -
                                        itemData.price) /
                                        itemData.originalPrice) *
                                        100}
                                      %
                                    </div> 
                                  </Col>*/}
                                        <Col
                                          className={classNames(
                                            "text-center fs-0 my-auto",
                                            {
                                              " text-success fw-bold ":
                                                selectValue[itemData.id] > 0,
                                            }
                                          )}
                                        >
                                          <span className=" fw-bold">
                                            <SplitNumber
                                              number={itemData.price}
                                            />
                                          </span>{" "}
                                          <span className="fs-075">تومان</span>
                                        </Col>
                                        <Col xs="auto" className=" my-auto">
                                          {itemData.isFullCapacity ||
                                          item.iIFC ? (
                                            <div
                                              className="text-center fs-07 small-svg text-muted"
                                              style={{ width: "80px" }}
                                            >
                                              <IconPeople />
                                              تکمیل ظرفیت
                                            </div>
                                          ) : group_ReceptionHoursAreOver ||
                                            item_ReceptionHoursAreOver ? (
                                            <div
                                              className="text-center fs-07 small-svg text-muted"
                                              style={{ width: "80px" }}
                                            >
                                              <IconHourGlass />
                                              اتمام ساعت پذیرش
                                            </div>
                                          ) : !item.iIA ||
                                            !itemData.isActive ? (
                                            <div
                                              className="text-center fs-07 very-small-svg text-muted"
                                              style={{ width: "80px" }}
                                            >
                                              <IconForbidden />
                                              عدم فعالیت
                                            </div>
                                          ) : !_.isEmpty(
                                              itemData.reservationByPhone
                                            ) ? (
                                            <a
                                              href={`tel:${itemData.reservationByPhone}`}
                                              className="text-center fs-07 d-inline-block rounded-2 py-1"
                                              style={{
                                                width: "80px",
                                                color: "#ed7070",
                                                border:
                                                  "1px solid rgb(237 112 112 / 30%)",
                                                backgroundColor:
                                                  "rgb(237 112 112 / 12%)",
                                              }}
                                            >
                                              <div className="flipX small-svg d-inline-block">
                                                <IconPhone fillColor="rgb(237, 112, 112)" />
                                              </div>
                                              رزرو تلفنی
                                            </a>
                                          ) : (
                                            <select
                                              className={
                                                "form-select text-center"
                                              }
                                              //className={"form-select text-center",itemBasketCount>0?" text-success fw-bold":""}

                                              style={{ width: "80px" }}
                                              value={
                                                _.isNil(itemBasketCount)
                                                  ? 0
                                                  : itemBasketCount
                                              }
                                              onChange={(e) =>
                                                handleAddToBasket(
                                                  groupData,
                                                  itemData,
                                                  e.target.value
                                                )
                                              }
                                            >
                                              {" "}
                                              {[
                                                ...Array(
                                                  _.toInteger(item.iC) + 1
                                                ),
                                              ].map(
                                                (x, i) =>
                                                  (i >= item.iMinC ||
                                                    i == 0) && (
                                                    <option value={i}>
                                                      {i}
                                                    </option>
                                                  )
                                              )}
                                            </select>
                                          )}
                                        </Col>
                                      </Row>
                                    </div>
                                  </>
                                );
                            })}
                          </div>
                        </div>
                      </>
                    );
                })}
              </Fade>
            </div>
          ) : (
            <>
              <div className="md-svg text-center">
                <IconClosePaper fillColor="#b5b5b5" />
              </div>
              {selectedDateDescription?.desc && (
                <Alert variant="warning" className="fs-09 text-center">
                  <IconErrorCircle fillColor="#664d03" />
                  {selectedDateDescription?.desc}
                </Alert>
              )}
            </>
          )}
        </div>
      </>
    );
  };
  const handleClose = () => {
    setShowReserveModal(false);
  };
  const [selectValue, setSelectValue] = useState({});
  const sweetAlertModal = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-outline-success mt-2",
    },
    buttonsStyling: false,
  });

  const navigate = useNavigate();

  const handleAddToBasket = async (groupData, itemData, itemCount) => {
    setLoadingDot(true);
      let personsList = [];
      for (let i = 0; i < _.toNumber(itemCount); i++) {
        personsList.push({ basketPersonPersonFullName: " "});
      }
    const details = [];
    details.push({
      id: groupData.id,
      text: groupData.title,
      originalPrice: 0,
      price: 0,
      type: "group",
    });
    details.push({
      id: itemData.id,
      text: itemData.title,
      originalPrice: _.toNumber(itemData.originalPrice),
      price: _.toNumber(itemData.price),
      type: "item",
    });
    await BasketHelper.addItemToBasket(
      ctx,
      _.toNumber(itemCount),
      itemData.originalPrice, //_.toString(sumOriginalPrice),
      itemData.price, //_.toString(sumPrice),
      serviceInfo.id,
      serviceInfo.name,
      serviceInfo.imageUrl,
      null,
      "",
      selectedDate.date,
      JSON.stringify(details),
        //await BasketHelper.addBasketPersonList(ctx, personsList),
        personsList,
      0, // props.reserveDetails.Id,
      itemData.id,
      groupData.id
    );
    if (itemCount > 0) {
      setLoadingDot(false);
      sweetAlertModal
        .fire({
          icon: "success",
          title: " آیتم زیر به سبد خرید اضافه شد.",
          showClass: {
            popup: `
            animate__animated
            animate__fadeIn
            animate__faster            `,
          },
          hideClass: {
            popup: `
            animate__animated
            animate__fadeOut
            animate__faster            `,
          },
          html:
            "<div class='border rounded-3 px-3 py-2'>" +
            "<div class='row'>" +
            "<div class='col align-items-center py-1 text-start fw-bold' >" +
            serviceInfo.name +
            "<div class='fs-075 text-start'>" +
            groupData.title +
            " " +
            itemData.title +
            "</div>" +
            "<div class='fs-07  text-start'><span class='fw-normal'> تاریخ استفاده : </span>" +
            selectedDate.date +
            "</div>" +
            "</div>" +
            "<div class='col-auto border-start fw-bold fs-102 text-end my-auto'>" +
            itemCount +
            " عدد " +
            "</div>" +
            "</div></div>",
          confirmButtonText: "تایید و پرداخت",
          showCancelButton: "true",
          cancelButtonText: "اضافه کردن سایر تفریحات به سبد خرید",
        })
        .then((result) => {
          if (result.isConfirmed) {
            navigate("/basket");
          }
        });
    } else {
      sweetAlertModal.fire({
        icon: "success",
        text: "این آیتم از سبد خرید حذف شد",
        timer: 1500,
        showConfirmButton: false,
      });
      setLoadingDot(false);
      // sweetAlertModal
      //   .fire({
      //     icon: "warning",
      //     iconColor: "#ed725d",
      //     text: "این تفریح از سبد خرید حذف شود؟",
      //     cancelButtonText: "انصراف",
      //     confirmButtonText: "حذف شود",
      //     showCancelButton: true,
      //   })
      //   .then((result) => {
      //     /* Read more about isConfirmed, isDenied below */
      //     if (result.isConfirmed) {
      //       setSelectValue((prevState) => ({
      //         ...prevState,
      //         [itemCount]: itemCount,
      //       }));
      //       ServiceStorage.setBasket(false);
      //       sweetAlertModal.fire({
      //         icon: "success",
      //         text: "این آیتم از سبد خرید حذف شد",
      //         timer: 1500,
      //         showConfirmButton: false,
      //       });
      //     }
      //   });
    }
  };
  return (
    <>
      <Modal
        show={showReserveModal}
        scrollable
        fullscreen="md-down"
        onHide={handleClose}
      >
        <Modal.Header className="d-block bg-gray-4 p-2">
          <Modal.Title className="large-svg mb-2">
            <button
              type="button"
              className="btn-no-style"
              onClick={handleClose}
            >
              <IconArrowRight fillColor="#000" />
            </button>
            <span className="fw-bold fs-101">{serviceInfo.name}</span>
          </Modal.Title>
          {loadingSwiperDate ? (
            <div className="swiper-container">
              <Swiper
                ref={swiperRef}
                className="date-swiper "
                spaceBetween={5}
                slidesPerView={"auto"}
                navigation={{ prevEl: ".prev", nextEl: ".next" }}
                modules={[Navigation]}
                initialSlide={firstSelectableDateIndex}
                // navigation={true}
              >
                {loadingData
                  ? list.map((item, index) => (
                      <SwiperSlide key={index}>
                        <Card>
                          <Card.Body className="py-2 px-1">
                            <SkeletonTheme>
                              <Skeleton
                                width="80%"
                                height="10px"
                                className="text-center"
                              ></Skeleton>
                              <Skeleton width="100%" height="10px"></Skeleton>
                              {/* <Skeleton
                          width="88%"
                          height="10px"
                          className="text-center"
                        ></Skeleton> */}
                            </SkeletonTheme>
                          </Card.Body>
                        </Card>
                      </SwiperSlide>
                    ))
                  : createDatePickerSlider()}
              </Swiper>
              <div className="custom-navigation">
                <button
                  className="prev flipX"
                  onClick={() => swiperRef.current.swiper.slidePrev()}
                >
                  <IconChevronLeft fillColor="#444" />
                </button>
                <button
                  className="next "
                  onClick={() => swiperRef.current.swiper.slideNext()}
                >
                  <IconChevronLeft fillColor="#444" />
                </button>
              </div>
            </div>
          ) : (
            <Swiper
              className="date-swiper "
              spaceBetween={5}
              slidesPerView={"auto"}
            >
              {list.map((item, index) => (
                <SwiperSlide key={index}>
                  <Card>
                    <Card.Body className="py-2 px-1">
                      <SkeletonTheme>
                        <Skeleton
                          width="80%"
                          height="10px"
                          className="text-center"
                        ></Skeleton>
                        <Skeleton width="100%" height="10px"></Skeleton>
                        {/* <Skeleton
                  width="88%"
                  height="10px"
                  className="text-center"
                ></Skeleton> */}
                      </SkeletonTheme>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </Modal.Header>
        <Modal.Body className="mb-5 px-2 pt-1 position-relative">
          <form noValidate autoComplete="off" className="loading-form-bg ">
            {loadingData ? <SkeletonModalReserveItem /> : createReserveForm()}
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={modalInfo.show}
        onHide={(e) => {
          setModalInfo({ ...modalInfo.show, show: false });
        }}
        centered
      >
        <Modal.Header
          closeButton
          onClick={(e) => {
            setModalInfo({ ...modalInfo.show, show: false });
          }}
          className="pt-2 border-0"
        >
          <Modal.Title>توضیحات</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-align-justify fs-8 text-dark pt-0 line-height-1 description-text">
          <div dangerouslySetInnerHTML={{ __html: modalInfo?.text }} />
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="primary"
            className="fs-075 px-3"
            onClick={(e) => {
              setModalInfo({ ...modalInfo.show, show: false });
            }}
          >
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReserveModal;
